import { useBorrowerPmcWebsite } from '../../../../../../../queries/BorrowerFields/PmcFields';
import { UrlBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface PropertyManagementCompanyWebsiteProps {
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
}

//TODO: handle submitted / validation if need be
export const PropertyManagementCompanyWebsite: React.FC<PropertyManagementCompanyWebsiteProps> = ({
    required = false,
    readOnly = false,
    isReview = false,
}) => {
    const label = 'Website';
    const [website, set_companyWebsite] = useBorrowerPmcWebsite();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={website}
                />
            ) : (
                <UrlBox
                    id='propertyManagementCompanyName'
                    value={website}
                    onChange={(value) => set_companyWebsite(value)}
                    label={label}
                    placeholder='www.somecompany.com'
                    required={required}
                    width='100%'
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
